import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import ConfirmModal from '../../../utilities/form-components/ConfirmModal';
import { isSothebys } from '../../../utilities/BusinessLogic';
import {
  ahPath,
  cfPath,
  isProd,
  sellerConsolePath,
  testBidderPath,
} from '../../../utilities/UrlPaths';

/**
 * This component represents the dropdown actions.  This had to be a component entirely because
 * of the toteboard path.  The toteboard path needs to remain invisible until the launch seller
 * console link is clicked.
 */
class ActionsCurrent extends Component {
  constructor(props) {
    super(props);
    const {
      auction: {
        current: { stepTracker }
      },
      values: { catalogID }
    } = props;
    this.state = {
      showModal: false,
      showToteboard: false,
      step: stepTracker[catalogID]
    };
  }

  handleSellerConsoleClick = () => {
    this.setState({ showToteboard: true });
  };

  toggleModal = () => {
    this.setState({
      showModal: !this.state.showModal
    });
  };

  render() {
    const { groupID, handleDeleteSession, houseID, live, user, house, values } = this.props;
    const { showModal, step } = this.state;
    const { accessConsole, accessReports } = user;
    const { connectType, houseRef } = house;

    const {
      catalogGUID,
      catalogID,
      catalogRef,
      in2Hours,
      ir5VideoEnabled,
      liveServerID,
      lotCount,
      webRTCEnabled
    } = values;

    let { showToteboard } = this.state;

    const checkLivePublishedLot = lotCount > 0 && !!live;
    const checkEnvironment = !isProd || (isProd && in2Hours);
    const showDropdownItem = checkLivePublishedLot && checkEnvironment;
    const showVideo = showDropdownItem && !!(webRTCEnabled || ir5VideoEnabled);

    showToteboard = showToteboard || (checkLivePublishedLot && liveServerID > 0);

    const showTestBidderConsoleLink = isSothebys(houseID) && checkLivePublishedLot;
    const showConsoleOnlyDropdownItem = showDropdownItem && accessConsole;
    const showDivider = showTestBidderConsoleLink || showConsoleOnlyDropdownItem;
    const ycConnectTypes = ['s', 'p', 'e'];
    const isConnectHouse = ycConnectTypes.indexOf(connectType) > -1;

    const isTimed = !live;
    const editSessionLink = `/session/${live ? 'live' : 'timed'}/${groupID}/${catalogID}/${step}`;
    const bulkBiddingLink = `/bulk-bidding/${catalogRef}`;

    const saleroomConsolePath = `https://${isProd ? 'live' : 'stg-live'}.invaluableauctions.com/`;

    return (
      <UncontrolledDropdown className="w-100">
        <DropdownToggle caret color="white">
          Select Action
        </DropdownToggle>
        <DropdownMenu className="actions-dropdown-menu">
          {showTestBidderConsoleLink && (
            <DropdownItem
              href={testBidderPath(catalogRef)}
              target="_blank"
              rel="noopener noreferrer"
              name="test-bidder-console"
            >
              Test Bidder Console <FontAwesomeIcon icon="external-link-alt" />
            </DropdownItem>
          )}

          {showConsoleOnlyDropdownItem && (
            <DropdownItem
              href={`${sellerConsolePath(catalogGUID, catalogRef)}`}
              target="_blank"
              rel="noopener noreferrer"
              name="open-seller-console"
              className="text-danger font-weight-bold"
              onClick={() => this.handleSellerConsoleClick()}
            >
              Open Seller Console <FontAwesomeIcon icon="external-link-alt" />
            </DropdownItem>
          )}

          {/* Basically... if one of the above two is visible, we want a divider... */}
          {showDivider && <DropdownItem divider />}

          <DropdownItem tag={Link} to={editSessionLink} name="edit-session">
            Edit Session
          </DropdownItem>

          {user.accessBulkbiding && isTimed && (
            <DropdownItem
              disabled={lotCount === 0}
              tag={Link}
              to={bulkBiddingLink}
              name="bulk-bidding"
            >
              Bulk Bidding
            </DropdownItem>
          )}

          {showVideo && accessConsole && (
            <DropdownItem
              tag={Link}
              to={`/broadcast/${catalogRef}?isWebRtc=${webRTCEnabled ? 1 : 0}`}
              name="start-video-broadcast"
            >
              Start Video Broadcast
            </DropdownItem>
          )}

          {showConsoleOnlyDropdownItem && (
            <DropdownItem
              target="_blank"
              rel="noopener noreferrer"
              href={`${saleroomConsolePath}saleroom/${catalogRef}`}
              name="open-sale-room-console"
            >
              Open Saleroom Console <FontAwesomeIcon icon="external-link-alt" />
            </DropdownItem>
          )}

          {showToteboard && accessConsole && (
            <DropdownItem
              target="_blank"
              rel="noopener noreferrer"
              href={`${saleroomConsolePath}toteboard/${catalogRef}`}
              name="open-toteboard"
            >
              Auctioneer’s Tote Board <FontAwesomeIcon icon="external-link-alt" />
            </DropdownItem>
          )}

          {accessReports && (
            <DropdownItem
              href={`${cfPath()}/al/stats/viewCatalogSummary.cfm?catalogIDList=${catalogID}`}
              name="view-session-stats"
            >
              View Session Stats{' '}
            </DropdownItem>
          )}

          {isConnectHouse && (
            <DropdownItem
              href={`${ahPath()}/app/house/${houseRef}/maxBidReports?catalogRefs=${catalogRef}`}
              name="download-absentee-bids"
            >
              Download PL Absentee Bids{' '}
            </DropdownItem>
          )}

          {/* Displaying the divider */}
          {lotCount === 0 && <DropdownItem divider />}

          {lotCount === 0 && (
            <DropdownItem href={null} onClick={this.toggleModal} name="delete-session">
              Delete Session
            </DropdownItem>
          )}
        </DropdownMenu>
        {/* Displaying the Delete Modal Popup */}
        <ConfirmModal
          actionFunction={() => handleDeleteSession(catalogID)}
          bodyText="Are you sure you want to delete this session? Once deleted, this action can not be undone."
          buttonText="Delete"
          showModal={showModal}
          title="Delete Session"
          toggleFunction={this.toggleModal}
        />
      </UncontrolledDropdown>
    );
  }
}
const mapStateToProps = ({ auction, user, house }) => ({
  auction,
  user,
  house
});
export default connect(mapStateToProps, null)(ActionsCurrent);
